import { createContext } from 'react';

export type HeaderPanelId = 'search' | 'menu';

export type HeaderPanelContextValue = {
    isSearchSuggestionsOpen: boolean;
    setPanelOpen: (panel: HeaderPanelId, open: boolean) => void;
    /** Register the panel's close callback so the shared backdrop can dismiss it. */
    registerPanelCloseHandler: (panel: HeaderPanelId, handler: (() => void) | null) => void;
};

export const HeaderPanelContext = createContext<HeaderPanelContextValue | null>(null);
